import { motion, type Variants } from "framer-motion";

import { useStepperContext } from "./useStepper";

export interface StepProps {
  children: React.ReactNode;
  className?: string;
  id: number;
}

export function Step({
  children,
  className = "flex flex-col w-full gap-4",
  id,
}: StepProps) {
  const { activeStep, direction, handleAnimationComplete, isExiting } =
    useStepperContext();

  const isActive = activeStep === id;

  const variants: Variants = {
    animate: {
      opacity: 1,
      transition: { duration: 0.3, ease: "easeOut" },
      x: 0,
    },
    exit: (direction: number) => ({
      opacity: 0,
      transition: { duration: 0.2, ease: "easeIn" },
      x: direction > 0 ? -50 : 50,
    }),
    initial: (direction: number) => ({
      opacity: 0,
      x: direction > 0 ? 50 : -50,
    }),
  };

  return (
    <motion.div
      animate={isActive ? (isExiting ? "exit" : "animate") : "initial"}
      className={isActive ? className : "hidden"}
      custom={direction}
      initial="initial"
      onAnimationComplete={(definition) =>
        isActive && handleAnimationComplete(definition as string)
      }
      variants={variants}
    >
      {children}
    </motion.div>
  );
}
